import React, { useState } from "react";
import { getAPI } from "../../Global";
import { Box } from "@mui/material";
import CrudManager from "../../utils/Crud-Manager/CrudManager";
import schema from "./Data/InvestmentCRUDConfig.json";
import PageHeader from "../../components/PageHeader";
import { toast } from "react-toastify";
import "../../Assets/Styles/Style.css";
// import CardSummary from "../../utils/Card/CardSummary";
import InvestmentDataDisplay from "../../components/descriptionshow/GetByInvestmentNo";
import useApi from "../../utils/useApi";

const InvestmentPage = () => {
  const [value, setValue] = useState("");
  const [data, setData] = useState(null);
  const { Get } = useApi();
  const makeRequest = async () => {
    try {
      const response = await Get(
        `${getAPI("getTransactionsByInvestmentNo")}${value}/`
      );
      setData(response);
      setValue("");
    } catch (error) {
      toast.error(`No Investment found with number ${value}`);
      setValue("");
      setData(null);
    }
  };
  const handleInputChange = (e) => {
    setValue(e.target.value);
  };
  const handleSearch = () => {
    makeRequest();
  };
  return (
    <Box sx={{ display: "flex" }}>
      <Box
        sx={{
          flexGrow: 1,
          marginTop: 0,
          marginLeft: 15,
          marginRight: 15,
          marginBottom: 15,
        }}
      >
        <PageHeader pageTitle="Manage Your Investment" />
        <h2
          style={{
            fontSize: "1.5rem",
            margin: "2px 0",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
          }}
        >
          Enter An Investment Number And Get Investment Details
        </h2>
        <div className="search-container">
          <>
            <input
              type="text"
              value={value}
              onChange={handleInputChange}
              placeholder="Enter an investment number..."
              className="search-input"
            />
            <button onClick={handleSearch} className="search-button">
              Search
            </button>
          </>
        </div>
        {data && (
          <div style={{ marginBottom: "20px" }}>
            <InvestmentDataDisplay data={data} />
          </div>
        )}
        <div>
          {/* <CardSummary
            cards={[
              {
                title: "Total Groups",
                dataKey: "total_groups",
                image: "./assets/img/Groups.png",
              },
              {
                title: "Subscriptions",
                dataKey: "total_subscriptions",
                image: "./assets/img/subscribe.png",
              },
              {
                title: "Investments",
                dataKey: "total_invested",
                image: "./assets/img/total-subscription.png",
              },
              {
                title: "Penalty",
                dataKey: "total_penalty",
                image: "./assets/img/penalty-card.png",
              },
            ]}
          /> */}
        </div>
        {/* <hr /> */}
        <CrudManager
          data={schema}
          createRequired={false}
          editRequired={false}
          actionBtnName="Add New Investment"
          createFormTitle="Add Investment"
          updateFormTitle="Update Investment"
        />
      </Box>
    </Box>
  );
};
export default InvestmentPage;
